"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var PullDownThick = function PullDownThick(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "pull-down-thick"), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M17.96 5.72c-0.193-0.198-0.462-0.321-0.76-0.321s-0.567 0.123-0.76 0.321l-0 0-6.44 6.46-6.44-6.46c-0.194-0.194-0.463-0.315-0.76-0.315-0.594 0-1.075 0.481-1.075 1.075 0 0.297 0.12 0.566 0.315 0.76v0l7.2 7.2c0.195 0.193 0.464 0.313 0.76 0.313s0.565-0.119 0.76-0.313l7.2-7.2c0.198-0.193 0.321-0.462 0.321-0.76s-0.123-0.567-0.321-0.76l-0-0z"
  }));
};
var _default = exports["default"] = PullDownThick;